import {createContext, useEffect, useState} from "react";
// import { getDateRange } from "./helper";

export const AppContext = createContext();

export default function AppContextApi({children}) {

    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const userInfo = localStorage.getItem('userInfo'); // It was stringified, so should be parsed while setting user

        if (userInfo) {
            setUser(JSON.parse(userInfo));
        }
        setIsLoading(false);
    }, [])

    const [mapModal, setMapModal] = useState(false);
    const [activityLogs, setActivityLogs] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);

    return (
        <AppContext.Provider value={
            {
                user,
                setUser,
                isLoading,
                mapModal,
                setMapModal,
                activityLogs,
                setActivityLogs,
                page,
                setPage,
                rowsPerPage,
                setRowsPerPage,
                count,
                setCount
                //  imgCarousel, setImgCarousel, data, setData , filters_state  , setFilters_State , ,map_polygons , setMap_polygons ,options , setOptions , popups_ans, setShowpopups_ans ,popups, setShowpopups,downloadState , setDownloadState,images_url , setImages_url,polygon_GT , setPolygon_GT,sort, setSort,sortState , setSortState,selectedDI, setSelectedDI ,week , setWeek, alertTable , setAlertTable,weekvalue , setWeekValue
            }}> {children} </AppContext.Provider>
    )
}